import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../config";
import SaleHeader from "../../../Pdf/PrintHeaderAccount";
import PrintFooter from "../../../Pdf/PrintFooter";
import { saleReportStyles } from "../../../Pdf/pdfStyles";
import { PrintFormateNumber, parseReportAmount } from "../../../Pdf/PrintFormateNumber";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import moment from "moment";

const SALE_COL = {
  sr: 26,
  receipt: 46,
  dated: 54,
  customer: 112,
  product: 74,
  vehicle: 46,
  price: 52,
  qty: 52,
  amount: 105,
};
const SALE_TABLE_WIDTH =
  SALE_COL.sr +
  SALE_COL.receipt +
  SALE_COL.dated +
  SALE_COL.customer +
  SALE_COL.product +
  SALE_COL.vehicle +
  SALE_COL.price +
  SALE_COL.qty +
  SALE_COL.amount;

const SUMMARY_COL = {
  sr: 26,
  code: 130,
  name: 150,
  qty: 130,
  amount: 131,
};

const buildSummaryFromSales = (list) => {
  const grouped = new Map();

  (list || []).forEach((item) => {
    const productId = item.Product_ID || item.Product_BE?.ID;
    if (!productId) return;

    const key = String(productId);
    const row = grouped.get(key) || {
      ProductCode: item.Product_BE?.ProductCode || "",
      Name: item.Product_BE?.Name || "",
      Balance: 0,
      Amount: 0,
    };

    row.Balance += Number(item.Quantity) || 0;
    row.Amount += Number(item.Amount) || 0;
    grouped.set(key, row);
  });

  return Array.from(grouped.values()).sort((a, b) =>
    (a.ProductCode || "").localeCompare(b.ProductCode || "")
  );
};

const parseFilterId = (value) => {
  const id = parseInt(value, 10);
  return Number.isFinite(id) && id > 0 ? id : 0;
};

const resolveProductLabel = (productId, urlName, salesList, saleSummary) => {
  if (urlName) return decodeURIComponent(urlName);
  if (!productId) return "All Products";

  const fromSale = (salesList || []).find(
    (s) => (s.Product_ID || s.Product_BE?.ID) === productId
  );
  if (fromSale?.Product_BE?.Name) return fromSale.Product_BE.Name;

  const fromSummary = (saleSummary || []).find((s) => s.ID === productId);
  if (fromSummary?.Name) return fromSummary.Name;

  return "Selected Product";
};

const resolveCustomerLabel = (accountId, urlName, salesList) => {
  if (urlName) return decodeURIComponent(urlName);
  if (!accountId) return "All Customers";

  const fromSale = (salesList || []).find(
    (s) => (s.Account_ID || s.Account_BE?.ID) === accountId
  );
  if (fromSale?.Account_BE?.Name) return fromSale.Account_BE.Name;

  return "Selected Customer";
};

function PrintSaleReport() {
  const [loading, setLoading] = useState(false);

  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");

  const urlParams = new URLSearchParams(window.location.search);
  const StartDate = urlParams.get("StartDate");
  const EndDate = urlParams.get("EndDate");
  const ProductID = urlParams.get("ProductID");
  const AccountID = urlParams.get("AccountID");
  const ProductName = urlParams.get("ProductName");
  const CustomerName = urlParams.get("CustomerName");
  const [data, setData] = useState({});
  const[saleSummary,setSaleSummary]=useState([]);


  const [salesList, setSalesList] = useState([]);

  useEffect(() => {
    document.title = "Print Sale Report";
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      PageNo: 1,
      PageSize: 20000,
      StartDate: StartDate,
      EndDate: EndDate,
      ProductID: ProductID,
      CustomerID: AccountID,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Report/GetSalesReport",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };


    axios(api_config)
      .then(function (response) {
   
        if (response.data.status_code == 1) {
          setSalesList(response.data.listofSales);
          setSaleSummary(response.data.SaleSummary)
          setData(response.data);

          setLoading(false);
        } else {
          // Handle error
          setLoading(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const generateData = () => {
    if (salesList.length > 0) {
      return salesList.map((item, index) => {
        return (
          <View key={index} style={saleReportStyles.row}>
            <View style={[saleReportStyles.td, { width: SALE_COL.sr }]}>
              <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SALE_COL.dated }]}>
              <Text style={saleReportStyles.tdValue}>
                {moment(item.Sale_Invoice_Head_BE?.Dated).format(config.date_format)}
              </Text>
            </View>
            <View style={[saleReportStyles.td, { width: SALE_COL.customer }]}>
              <Text style={saleReportStyles.tdValue}>{item.Account_BE?.Name}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SALE_COL.product }]}>
              <Text style={saleReportStyles.tdValue}>{item.Product_BE?.Name}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SALE_COL.receipt }]}>
              <Text style={saleReportStyles.tdValue}>{item.Receipt_No}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SALE_COL.vehicle }]}>
              <Text style={saleReportStyles.tdValue}>{item.Vehicle_No}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SALE_COL.price, textAlign: "right" }]}>
              <Text style={saleReportStyles.tdValue}>{PrintFormateNumber(item.Price,2)}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SALE_COL.qty, textAlign: "right" }]}>
              <Text style={saleReportStyles.tdValue}>{PrintFormateNumber(item.Quantity,2)}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SALE_COL.amount, textAlign: "right" }]}>
              <Text style={saleReportStyles.tdValue}>{PrintFormateNumber(item.Amount,0)}</Text>
            </View>
          </View>
        );
      });
    }
  };

  const genrateSaleSummary = () => {
    const summaryRows =
      saleSummary && saleSummary.length > 0
        ? saleSummary
        : buildSummaryFromSales(salesList);

    if (summaryRows.length > 0) {
      return summaryRows.map((item, index) => {
        return (
          <View key={index} style={saleReportStyles.row}>
            <View style={[saleReportStyles.td, { width: SUMMARY_COL.sr }]}>
              <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
            </View>
           
            <View style={[saleReportStyles.td, { width: SUMMARY_COL.code }]}>
              <Text style={saleReportStyles.tdValue}>{item.ProductCode}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SUMMARY_COL.name }]}>
              <Text style={saleReportStyles.tdValue}>{item.Name}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SUMMARY_COL.qty, textAlign:'right' }]}>
              <Text style={saleReportStyles.tdValue}>{PrintFormateNumber(item.Balance)}</Text>
            </View>
            <View style={[saleReportStyles.td, { width: SUMMARY_COL.amount, textAlign:'right' }]}>
              <Text style={saleReportStyles.tdValue}>{PrintFormateNumber(item.Amount,0)}</Text>
            </View>
          </View>
        );
      });
    }
  };

  const MyDocument = () => {
    const productId = parseFilterId(ProductID);
    const accountId = parseFilterId(AccountID);
    const productLabel = resolveProductLabel(
      productId,
      ProductName,
      salesList,
      saleSummary
    );
    const customerLabel = resolveCustomerLabel(
      accountId,
      CustomerName,
      salesList
    );
    const periodLabel = `${
      StartDate ? moment(StartDate).format(config.date_format) : "-"
    } to ${EndDate ? moment(EndDate).format(config.date_format) : "-"}`;

    return (
    <Document>
      <Page size="A4" style={saleReportStyles.page}>
        <SaleHeader compact />
        <View style={saleReportStyles.section}>
          <View style={saleReportStyles.titleBlock}>
            <Text style={saleReportStyles.pagetitle}>Sales Report</Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Period: {periodLabel}
            </Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Customer: {customerLabel}    Product: {productLabel}
            </Text>
          </View>
          <View style={saleReportStyles.table}>
            <View style={saleReportStyles.tableHead}>
              <View style={[saleReportStyles.th, { width: SALE_COL.sr }]}>
                <Text style={saleReportStyles.thValue}>Sr. No.</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.dated }]}>
                <Text style={saleReportStyles.thValue}>Dated</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.customer }]}>
                <Text style={saleReportStyles.thValue}>Customer</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.product }]}>
                <Text style={saleReportStyles.thValue}>Product</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.receipt }]}>
                <Text style={saleReportStyles.thValue}>Receipt</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.vehicle }]}>
                <Text style={saleReportStyles.thValue}>Vehicle</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.price, textAlign: "right" }]}>
                <Text style={saleReportStyles.thValue}>Price</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.qty, textAlign: "right" }]}>
                <Text style={saleReportStyles.thValue}>Quantity</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.amount, textAlign: "right" }]}>
                <Text style={saleReportStyles.thValue}>Amount</Text>
              </View>
            </View>

            {generateData()}

            <View style={saleReportStyles.totalsRow}>
              <View style={[saleReportStyles.th, { width: SALE_TABLE_WIDTH - SALE_COL.amount, textAlign: "right" }]}>
                <Text style={saleReportStyles.thValue}>Total Sales</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.amount, textAlign: "right" }]}>
                <Text style={saleReportStyles.thValue}>
                  {PrintFormateNumber(parseReportAmount(data.TotalSales), 0)}
                </Text>
              </View>
            </View>
            <View style={saleReportStyles.totalsRow}>
              <View style={[saleReportStyles.th, { width: SALE_TABLE_WIDTH - SALE_COL.amount, textAlign: "right" }]}>
                <Text style={saleReportStyles.thValue}>Cash Sales</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.amount, textAlign: "right" }]}>
                <Text style={saleReportStyles.thValue}>
                  {PrintFormateNumber(parseReportAmount(data.TotalCashSales), 0)}
                </Text>
              </View>
            </View>
            <View style={saleReportStyles.totalsRow}>
              <View style={[saleReportStyles.th, { width: SALE_TABLE_WIDTH - SALE_COL.amount, textAlign: "right" }]}>
                <Text style={saleReportStyles.thValue}>Credit Sales</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SALE_COL.amount, textAlign: "right" }]}>
                <Text style={saleReportStyles.thValue}>
                  {PrintFormateNumber(parseReportAmount(data.TotalCreditSales), 0)}
                </Text>
              </View>
            </View>
          </View>

          <View style={saleReportStyles.title}>
            <Text style={saleReportStyles.pagetitle}>Sales Summary</Text>
          </View>

          <View style={saleReportStyles.table}>
            <View style={saleReportStyles.tableHead}>
              <View style={[saleReportStyles.th, { width: SUMMARY_COL.sr }]}>
                <Text style={saleReportStyles.thValue}>Sr. No.</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SUMMARY_COL.code }]}>
                <Text style={saleReportStyles.thValue}>Product Code</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SUMMARY_COL.name }]}>
                <Text style={saleReportStyles.thValue}>Name</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SUMMARY_COL.qty, textAlign:'right' }]}>
                <Text style={saleReportStyles.thValue}>Quantity</Text>
              </View>
              <View style={[saleReportStyles.th, { width: SUMMARY_COL.amount, textAlign:'right' }]}>
                <Text style={saleReportStyles.thValue}>Amount</Text>
              </View>
            </View>
            {genrateSaleSummary()}
            
          </View>
          <View
            style={{ marginBottom: 20, marginTop: 0, top: 6, bottom: 6 }}
            fixed
          >
            <Text
              style={{ fontSize: "7pt", color: "#000" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
    );
  };

  return (
    <>
      <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
        {loading ? (
          <div
            style={{
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <PDFViewer width="100%" height="100%" fileName="sample.pdf">
            <MyDocument />
          </PDFViewer>
        )}
      </div>
    </>
  );
}

export default PrintSaleReport;
